import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
 
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ErrorHandlerDirective } from './directives/error-handler.directive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CommonRestService, DataService } from '@ace/ace';
import { BusinessCommonService } from '@ace/ace';
import { HttpInterceptorService } from './core/interceptor/httpinterceptor-service';
import {
  APP_ENVIRONMENT,
  LoaderComponent,
  NotificationsComponent,
  authInterceptorProviders,
} from '@ace/ace';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environments';
import { firstValueFrom } from 'rxjs';
import { PlatformFeaturesService } from './services/platform-features.service';
import { HomeworkAwareDataService } from './core/services/homework-aware-data.service';
import { SettingsComponent } from './features/settings/settings.component';
//import mainPages from './config/main-pages.json';
 
export function HttpLoaderFactory(http: HttpClient) {
  const langPath = './assets/i18n/';
  return new TranslateHttpLoader(http, langPath, '.json');
}

export function loadPlatformFeatures(service: PlatformFeaturesService) {
  return () => firstValueFrom(service.load());
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LoaderComponent,
    NotificationsComponent,
    SettingsComponent,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TranslateModule,
  ],
  providers: [
    authInterceptorProviders,
    CommonRestService,
    BusinessCommonService,
    { provide: DataService, useClass: HomeworkAwareDataService },
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    { provide: APP_ENVIRONMENT, useValue: environment },
    {
      provide: APP_INITIALIZER,
      useFactory: loadPlatformFeatures,
      deps: [PlatformFeaturesService],
      multi: true,
    },
    // { provide: ACE_MAIN_NAV_PAGES, useValue: mainPages },
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
